export const agents = {
  'system-analyst': {
    name: 'System Analyst',
    role: 'Requirements Translation',
    avatar: '🔍',
    description: 'Translates business requirements into technical specifications with deep domain understanding',
    tier: 'Core Agent',
    capabilities: ['Requirements Analysis', 'Technical Translation', 'Stakeholder Communication']
  },
  'developer': {
    name: 'Developer',
    role: 'Code Implementation',
    avatar: '👨‍💻',
    description: 'Implements features using specialized coding intelligence and best practices',
    tier: 'Specialist Agent',
    capabilities: ['Code Generation', 'Pattern Implementation', 'Performance Optimization']
  },
  'architect': {
    name: 'Architect',
    role: 'Technical Authority',
    avatar: '🏗️',
    description: 'Makes critical architectural decisions across projects with strategic oversight',
    tier: 'Elite Agent',
    capabilities: ['System Design', 'Technology Selection', 'Scalability Planning']
  },
  'techlead': {
    name: 'TechLead',
    role: 'Integration & DevOps',
    avatar: '⚙️',
    description: 'Ensures code quality, integration and handles deployment workflows',
    tier: 'Premium Agent',
    capabilities: ['Code Review', 'CI/CD Management', 'Quality Assurance']
  },
  'manager': {
    name: 'Manager/PO',
    role: 'Project Leadership',
    avatar: '📋',
    description: 'Manages project scope, priorities and stakeholder requirements',
    tier: 'Core Agent',
    capabilities: ['Project Planning', 'Scope Management', 'Stakeholder Alignment']
  },
  'senior-manager': {
    name: 'Senior Manager',
    role: 'Cross-Project Oversight',
    avatar: '👔',
    description: 'Coordinates multiple projects and strategic decisions across the portfolio',
    tier: 'Core Agent',
    capabilities: ['Portfolio Management', 'Resource Allocation', 'Strategic Planning']
  }
};

export const metrics = [
  { label: 'Projects Evolved', value: '1,247', icon: 'TrendingUp' },
  { label: 'Lines of Code', value: '2.1M+', icon: 'Code' },
  { label: 'Active Agents', value: '6 Core', icon: 'Bot' },
  { label: 'Evolution Speed', value: '24/7', icon: 'Zap' }
];

export const features = [
  {
    icon: 'Users',
    title: 'Executive AI Meetings',
    description: 'World-first implementation of corporate meetings between AI agents making real decisions.',
    status: 'Revolutionary',
    color: 'blue'
  },
  {
    icon: 'Zap',
    title: 'IDLE Mode Evolution',
    description: 'Projects evolve continuously while your machine is idle. Wake up to improved software.',
    status: 'Automated',
    color: 'green'
  },
  {
    icon: 'Bot',
    title: 'Hierarchical AI Governance',
    description: 'Six specialized agents work in corporate hierarchy, from Developer to Senior Manager.',
    status: 'Structured',
    color: 'purple'
  },
  {
    icon: 'Code',
    title: 'Multi-Project Learning',
    description: 'Agents learn from across projects, applying insights to improve all your software.',
    status: 'Intelligent',
    color: 'orange'
  }
];

export const tiers = [
  {
    name: 'Free',
    price: '$0',
    description: 'Perfect for individual developers and small projects',
    features: [
      'Paul Thompson (Free Consultant)',
      'Basic project evolution',
      '5 projects maximum',
      'Community support',
      'Standard evolution speed',
      'Core AI agents access'
    ],
    cta: 'Start Free',
    popular: false
  },
  {
    name: 'Startup',
    price: '$49',
    description: 'For growing startups and development teams',
    features: [
      'Sarah & Mike (Startup Consultants)',
      'Advanced architecture guidance',
      'Unlimited projects',
      'Priority support',
      '2x evolution speed',
      'Custom agent personalities',
      'Advanced analytics'
    ],
    cta: 'Upgrade to Startup',
    popular: true
  },
  {
    name: 'Business',
    price: '$149',
    description: 'For established businesses requiring premium AI minds',
    features: [
      'David & Lisa (Business Consultants)',
      'Business strategy integration',
      'Multi-team coordination',
      'Dedicated support',
      '5x evolution speed',
      'Custom agent development',
      'Advanced reporting'
    ],
    cta: 'Choose Business',
    popular: false
  },
  {
    name: 'Enterprise',
    price: 'Custom',
    description: 'For enterprises requiring the ultimate AI orchestration',
    features: [
      'Elite AI Consultant Team',
      'Custom AI agent development',
      'White-label solutions',
      '24/7 dedicated support',
      '10x evolution speed',
      'Enterprise integrations',
      'SLA guarantees'
    ],
    cta: 'Contact Sales',
    popular: false
  }
];
